import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://i.ibb.co/8ny9NnYx/file-0000000061ec6246b9957f80a80d50ea-1.png"
          alt="Goodys Streams Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        {/* Large Center Logo - 4x Bigger */}
        <div className="flex justify-center mb-12">
          <img 
            src="https://i.ibb.co/fYd7kNHp/file-000000009ccc71f4afb9271f0a21b384-1.png"
            alt="Goodys Streams Logo"
            className="h-[512px] md:h-[640px] lg:h-[768px] w-auto object-contain"
          />
        </div>

        <div className="text-center text-white mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Get Your Free 24-Hour Trial Today
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto">
            Professional device configuration and entertainment system optimization services
          </p>
        </div>

        {/* WhatsApp Contact Card */}
        <div className="max-w-md mx-auto bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 mb-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-whatsapp-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Contact Us on WhatsApp</h3>
                <p className="text-gray-600">+44 7438 913933</p>
              </div>
            </div>
            <a 
              href="https://wa.me/qr/QOVGSHQTONIKJ1"
              className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Chat Now
            </a>
          </div>
        </div>

        {/* About Us Section */}
        <div className="max-w-6xl mx-auto text-center mb-8 mt-12">
          <h3 className="text-7xl md:text-8xl lg:text-9xl font-black text-white mb-12 tracking-wide drop-shadow-lg">About Goody Streams</h3>
          <p className="text-white/95 leading-relaxed mb-10 text-4xl md:text-5xl lg:text-6xl font-semibold drop-shadow-md">
            Goody Streams was created to offer a smarter, more affordable way to watch premium entertainment.
          </p>
          <p className="text-white/90 leading-relaxed mb-10 text-3xl md:text-4xl lg:text-5xl font-medium drop-shadow-md">
            In the UK, a full cable TV package with sports and movie channels can cost over <span className="text-orange-400 font-bold">£1,000 per year</span>. On top of that, most households also pay for multiple streaming subscriptions — with popular platforms averaging <span className="text-orange-400 font-bold">£10.99–£13.99 per month</span> each. When combined, the annual cost of entertainment can easily exceed <span className="text-red-400 font-bold">£1,300+ per year</span>.
          </p>
          <p className="text-white/95 leading-relaxed mb-10 text-4xl md:text-5xl lg:text-6xl font-bold drop-shadow-md">
            Goody Streams brings live TV, sports, movies, and on-demand content together in one simple app for just <span className="text-green-400 font-black text-5xl md:text-6xl lg:text-7xl">£80 per year</span>.
          </p>
          <p className="text-white/90 leading-relaxed text-3xl md:text-4xl lg:text-5xl font-medium drop-shadow-md">
            That means our members can save over <span className="text-green-400 font-bold">£1,200 annually</span> while enjoying everything in one place — no multiple subscriptions, no switching between apps, and no inflated bills. It's premium entertainment, simplified — without the premium price tag.
          </p>
        </div>

        {/* Free Trial WhatsApp Button */}
        <div className="max-w-md mx-auto">
          <a 
            href="https://wa.me/qr/QOVGSHQTONIKJ1"
            className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-4 rounded-2xl font-semibold hover:from-orange-600 hover:to-red-600 transition-all shadow-lg hover:shadow-xl flex items-center justify-center space-x-3 cursor-pointer"
          >
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-message-3-line text-xl"></i>
            </div>
            <span className="text-lg">Msg for free 24 hour trial</span>
          </a>
        </div>
      </div>
    </section>
  );
}
